import script from "./PublishDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublishDialog.vue?vue&type=script&setup=true&lang=ts"

import "./PublishDialog.vue?vue&type=style&index=0&id=38a5bca2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a5bca2"]])

export default __exports__